import React, {useState, useEffect} from 'react';
import {NavBar, Icon, Modal, Toast, ActivityIndicator} from 'antd-mobile';
import {Link} from 'react-router-dom';
import {Flex, Button, WhiteSpace, WingBlank} from 'antd-mobile';
import Product from '../models/Product';
import Payment from "../models/Payment";

import dal from '../data/DAL';

let debug = require('debug')('APP:ChargePlan')
const alert = Modal.alert;


/**
 * 套餐续费页面
 */
const ChargePlan: React.FC = (props: any) => {

    const [products, setProducts] = useState(new Array<Product>());
    const [payments, setPayments] = useState(new Array<Payment>());

    const [aliPayUrl, setAliPayUrl] = useState('');
    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        debug('ChargePlan useEffect');
        setAnimating(true);

        dal.syncServerUserData().then(rsp => {

            setAnimating(false);
            mapState()
        })
    }, []);

    const mapState = () => {
        setProducts(dal.state.products);
        setPayments(dal.state.paymentConfigs)

    };

    const payBtnClicked = (product: Product, payment: Payment) => {
        console.log('>>>>>>', product.id);
        if(payment.requireConfirm){
            const msg = payment.msg.replace("{price}",product.priceNew).replace("{product}",product.name)
            alert('确认支付', msg, [
                { text: '取消', onPress: () => console.log('cancel') },
                {
                    text: '确定',
                    onPress: ()=>{
                        payClickOk(product.id, payment)
                    }
                },
            ])
        }else{
            payClickOk(product.id, payment)
        }
    };

    const payClickOk =  (productId: string, payment: Payment) =>{
        setAnimating(true);
        console.log("payment：：：",payment)
        if (payment.payMethod === 'wx') {
            dal.getWXPayUrl(productId,payment.extra).then(rsp => {
                debug(rsp);
                if (rsp.data.status === 0) {
                    // let payUrl = rsp.data.data.param1
                    //     + '/api/payment/wxH5IosPayment.html?url='
                    //     + encodeURIComponent(rsp.data.data.payUrl)
                    invokeWXPaymentPage(rsp.data.data.payUrl);
                } else {
                    setAnimating(false);
                    Toast.fail(rsp.data.msg, 3);
                }
            })
        } else if (payment.payMethod === 'alipay') {
            dal.getAliPayUrl(productId,payment.extra).then(rsp => {
                debug(rsp)
                if (rsp.data.status === 0) {
                    invokePaymentPage(rsp.data.data.payUrl);
                } else {
                    setAnimating(false);
                    Toast.fail(rsp.data.msg, 3);
                }
            })
        }else if (payment.payMethod === 'pp') {
            dal.getPPPayUrl(productId,payment.extra).then(rsp => {
                debug(rsp)
                if (rsp.data.status === 0) {
                    invokePaymentPage(rsp.data.data.payUrl);
                } else {
                    setAnimating(false);
                    Toast.fail(rsp.data.msg, 3);
                }
            })
        }else if (payment.payMethod === 'up') {
            dal.getUPPayUrl(productId,payment.extra).then(rsp => {
                debug(rsp)
                if (rsp.data.status === 0) {
                    invokePaymentPage(rsp.data.data.payUrl);
                } else {
                    setAnimating(false);
                    Toast.fail(rsp.data.msg, 3);
                }
            })
        }
    }

    const showPaymentCheckModal = (orderId: string) => {
        Modal.alert('提示', '正在支付···', [
            {text: '支付失败', onPress: () => paymentCheck(orderId)},
            {text: '支付成功', onPress: () => paymentCheck(orderId)},
        ]);
    }

    const paymentCheck = (orderId: string) => {
        dal.getPayResult(orderId).then(rsp => {
            debug('验证支付', rsp);
            if (rsp.data.status === 0) {
                window.history.back();
            } else {
                Toast.fail(rsp.data.msg, 1);
            }
        });
    }

    const invokeWXPaymentPage = (payUrl: string) => {
        setAnimating(false);

        debug('invokeWXPaymentPage', payUrl);
        window.location.href = payUrl;
    }
    const invokePaymentPage = (payUrl: string) => {

        debug('invokePaymentPage', payUrl);
        setAnimating(false);
        if (payUrl.startsWith("http://") || payUrl.startsWith("https://")) {
            window.location.href = payUrl;
        } else {
            setAliPayUrl(payUrl);
            document.forms[0].submit();

        }
    }


    return (
        <div>
            <NavBar
                mode="light"
                /*                icon={<Link to={"/home"}><Icon color={'#666666'} size={'lg'} type="left"/></Link>}*/
                icon={<Icon color={'#666666'} size={'lg'} type="left"/>}
                onLeftClick={() => {
                    window.history.back()
                }}
                rightContent={[<Link key={'charge-history'} to={"/pay-history"}><span
                    style={{color: '#666666'}}>充值记录</span></Link>]}>
                充值
            </NavBar>
            <WhiteSpace size="lg"/>
            <Flex style={{flexWrap: "wrap"}}>
                {products.map((p, index) => {
                    return (
                        <div key={p.name + index} className={"charge-plan-block"}>
                            <div className={"charge-plan-inner"}>
                                <h2>{p.name}</h2>
                                <p style={{height: '2em'}}>{p.desc}</p>
                                <span className={"new-price"}>{p.priceNew}</span>
                                <span className={"price"}>{p.priceOld}</span>

                                <WhiteSpace/>
                                {payments.map((item,index)=>{
                                    return (
                                        <>
                                            <Button key={item.name} type="primary" size="small" style={{}} onClick={(e) => {
                                                payBtnClicked(p, item);
                                            }}>{item.name}</Button>
                                            <WhiteSpace/>
                                        </>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}
            </Flex>
            <p hidden={animating} style={{textAlign: 'center'}}>可重复购买，时间叠加</p>
            <div dangerouslySetInnerHTML={{__html: aliPayUrl}}/>
            <ActivityIndicator toast text="正在加载" animating={animating}/>
        </div>
    );
}


export default ChargePlan;